/*
  The one href gate for every Moments card. safeHref admits exactly two
  shapes — an absolute http(s) URL or a site-relative path — so a poisoned
  value (javascript:, data:, scheme-relative //…) never reaches an href.
  The hydrator sends in-app paths (/moments/<slug>, /shop/<username>,
  /shop/collections/<id>, product pages) alongside real web destinations.
*/
export const safeHref = value => {
  if (typeof value !== 'string') return null;
  const v = value.trim();
  // trim() only cleans the ends; browsers ALSO strip embedded tab/newline/CR
  // when resolving, so "/<tab>/evil.com" would collapse to "//evil.com" after
  // passing a naive prefix check. Reject them anywhere, in either shape.
  if (/[\t\n\r]/.test(v)) return null;
  if (/^https?:\/\//i.test(v)) return v;
  // Site-relative: one leading slash whose next character is no slash of
  // either kind — browsers treat "\" as "/", so "/\evil.com" is
  // scheme-relative in disguise.
  if (/^\/[^/\\]/.test(v)) return v;
  return null;
};

// Spread onto an <a> whose href passed safeHref: absolute URLs leave the
// site, so they open a new tab; site-relative paths navigate in place.
export const anchorProps = href => (/^https?:\/\//i.test(href) ? { href, target: '_blank', rel: 'noopener noreferrer' } : { href });

/*
  ProductCard's stricter gate. Its one consumer is the admin bench, whose
  hydrator ships only absolute http(s) urls — and whose origin serves no
  shopper routes, so a site-relative path reaching it could only resolve to
  a 404. Relatives are dropped: the card renders unlinked copy instead of a
  broken admin-origin link.
*/
export const safeAbsoluteHref = value => {
  const url = safeHref(value);
  return url && !url.startsWith('/') ? url : null;
};
